import { FC } from 'react';

import { GiftSellerTabbedPage } from '../components/GiftSellerTabbedPage';
import { GiftBrandSellerUserPage } from './GiftBrandSellerUserPage';
import { GiftDeliveryCategoryListPage } from './GiftDeliveryCategoryListPage';
import { GiftItemBrandListPage } from './GiftItemBrandListPage';

/**
 * 브랜드 관리 — 상품 브랜드(배송업체)·배송 카테고리·배송관리자 계정을 한 메뉴로.
 * 구 경로 /item-brand, /delivery-category, /brand-seller-user 는 라우터에서 탭으로 넘긴다.
 */
export const GiftBrandManagePage: FC = function GiftBrandManagePage() {
  return (
    <GiftSellerTabbedPage
      tabs={[
        { key: 'brand', label: '상품 브랜드', element: <GiftItemBrandListPage /> },
        {
          key: 'category',
          label: '배송 카테고리',
          element: <GiftDeliveryCategoryListPage />,
        },
        {
          key: 'seller',
          label: '배송관리자 계정',
          element: <GiftBrandSellerUserPage />,
        },
      ]}
    />
  );
};
